import React, { useState, useEffect } from 'react';
import Dropdown from 'react-bootstrap/Dropdown';

import './index.scss';

const areFilterValuesEqual = (value1, value2) => {
  return JSON.stringify(value1) === JSON.stringify(value2);
};

const ConversationQuickFilterDropdownItem = (props) => {
  const { label, value, selectedQuickFilter, onFilterSelect } = props;
  const isApplied = areFilterValuesEqual(selectedQuickFilter, value);
  return (
    <Dropdown.Item
      className="ConversationQuickFilterDropdown__menu-item"
      onClick={() => onFilterSelect(value)}
      title={label}
      aria-pressed={isApplied}
      role="menuitem"
    >
      <div>{label}</div>
    </Dropdown.Item>
  );
};

const ConversationQuickFilterDropdownSection = (props) => {
  const { label, options, selectedQuickFilter, onFilterSelect } = props;
  const menuItems = options.map((option, index) => {
    const { label, value } = option;
    return (
      <ConversationQuickFilterDropdownItem
        key={index}
        label={label}
        value={value}
        selectedQuickFilter={selectedQuickFilter}
        onFilterSelect={onFilterSelect}
      />
    );
  });
  return (
    <>
      <Dropdown.Header>{label}</Dropdown.Header>
      {menuItems}
    </>
  );
};

const useSelectedQuickFilter = (
  selectedQuickFilterValue,
  quickFilters,
  onFilterSelect
) => {
  const flattenedQuickFilers = quickFilters.flatMap(
    (filter) => filter.options || filter
  );

  const selectedQuickFilter = flattenedQuickFilers.find((quickFilter) => {
    return areFilterValuesEqual(quickFilter.value, selectedQuickFilterValue);
  });

  const hasNoSelectedQuickFilter = selectedQuickFilter === undefined;

  const resetQuickFilterIfNoneSelected = () => {
    if (hasNoSelectedQuickFilter) {
      onFilterSelect(null);
    }
  };

  useEffect(resetQuickFilterIfNoneSelected, [selectedQuickFilterValue]);

  if (hasNoSelectedQuickFilter) {
    return null;
  }

  return selectedQuickFilter;
};

const ConversationQuickFilterDropdown = (props) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const toggleDropdown = () => setIsDropdownOpen(!isDropdownOpen);
  const { quickFilters, currentFilter, onFilterSelect, selectedQuickFilter } =
    props;

  const selectedQuickFilterObject = useSelectedQuickFilter(
    selectedQuickFilter,
    quickFilters,
    onFilterSelect
  );

  const visibleFilters = quickFilters.filter((quickFilter) => {
    return quickFilter.shouldShowInFilter(currentFilter);
  });

  const renderMenuItem = (quickFilter, index, quickFilters) => {
    const { label, value, options } = quickFilter;
    const isLastItem = index === quickFilters.length - 1;
    if (options !== undefined) {
      return (
        <React.Fragment key={index}>
          <ConversationQuickFilterDropdownSection
            label={label}
            options={options}
            selectedQuickFilter={selectedQuickFilter}
            onFilterSelect={onFilterSelect}
          />
          {isLastItem ? null : <Dropdown.Divider />}
        </React.Fragment>
      );
    }
    return (
      <ConversationQuickFilterDropdownItem
        key={index}
        label={label}
        value={value}
        selectedQuickFilter={selectedQuickFilter}
        onFilterSelect={onFilterSelect}
      />
    );
  };

  const menuItems = visibleFilters.map(renderMenuItem);

  if (menuItems.length === 0 || selectedQuickFilterObject === null) {
    return null;
  }

  const caretIcon = isDropdownOpen ? 'far fa-angle-up' : 'far fa-angle-down';

  return (
    <Dropdown
      className="ConversationQuickFilterDropdown"
      show={isDropdownOpen}
      onToggle={toggleDropdown}
      drop="down"
    >
      <Dropdown.Toggle
        variant="seconday"
        as="button"
        className="gecko-btn gecko-ui-material btn btn-naked"
      >
        {selectedQuickFilterObject.label}
        <i className={caretIcon} />
      </Dropdown.Toggle>
      <Dropdown.Menu role="menu" className="gecko-dropdown-menu">
        <div className="ConversationQuickFilterDropdown__menu-container">
          {menuItems}
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default ConversationQuickFilterDropdown;
